<template>
    <div class="annt-doc-wrapper">
        <el-dropdown class="lang-seletor" trigger="click" v-if="isLogin">
            <el-button type="text" icon="el-icon-sort">{{ currentCustomerName }}</el-button>
            <template #dropdown>
                <el-dropdown-menu class="doc-dropdown">
                    <el-dropdown-item @click="toSwitchOwner(item)" v-for="item in ownerList" :key="item.userCode" :command="item.userCode">{{
                        item.abbreviation ? item.abbreviation : item.customerName
                    }}</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>
<script>
import { reactive, toRefs } from 'vue';
import { getCargoOwnerInfo, setToken, setCargoOwnerInfo, getToken } from '@/utils/auth';
import { formatLoginInfo } from '@/utils/index';
import { switchOwner } from '@/api/login.js';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
    name: 'SwitchOwner',
    setup() {
        const isLogin = getToken();
        const store = useStore();
        const router = useRouter();
        /** 数据 */
        const state = reactive({
            ownerList: JSON.parse(getCargoOwnerInfo()), // 货主列表
            currentOwner: '', // 当前货主
            currentCustomerName: ''
        });
        /* 获取当前货主 */
        const getGurrentOwner = () => {
            return formatLoginInfo(JSON.parse(getCargoOwnerInfo()));
        };
        state.currentCustomerName = getGurrentOwner().abbreviation ? getGurrentOwner().abbreviation : getGurrentOwner().customerName;

        /* 切换货主 */
        const toSwitchOwner = item => {
            item.mobile = store.state.user.user.contactsMobile;
            switchOwner(item).then(res => {
                if (res && +res.code === 0) {
                    setToken(res.data.token);
                    for (const key in state.ownerList) {
                        if (state.ownerList[key].anhzCode) {
                            // eslint-disable-next-line max-depth
                            if (state.ownerList[key].anhzCode === item.anhzCode) {
                                state.ownerList[key].flag = 0;
                            } else {
                                state.ownerList[key].flag = null;
                            }
                        }
                    }
                    setCargoOwnerInfo(JSON.stringify(state.ownerList));
                    router.push('/');
                    location.reload();
                }
            });
        };
        return {
            ...toRefs(state),
            getGurrentOwner,
            toSwitchOwner,
            store,
            router,
            isLogin
        };
    }
};
</script>
<style lang="less">
.annt-doc-wrapper {
    .icon-button {
        font-size: 14px;
    }
}
.doc-dropdown {
    padding: 8px 0;
    li {
        padding: 4px 16px;
    }
}
</style>
